var _this = this;

import { getUserAchievements as getUserAchievement } from '../generated';
export var getUserAchievementsExtended = function getUserAchievementsExtended(api, userId, imageType, acceptLanguage) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return getUserAchievement.apply(_this, [api, userId, imageType, acceptLanguage, options]);
};